// extracted by mini-css-extract-plugin
module.exports = {"box":"JoinUs_box_39M5C","cardList":"JoinUs_cardList_3tnQ7","card":"JoinUs_card_3byDb","cardTitle":"JoinUs_cardTitle_XVkGJ"};